import { Recipient } from './../communication/model/recipient';
import {Input, NgModule, Component, OnInit, OnDestroy, OnChanges, SimpleChanges, Output, EventEmitter} from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, FormBuilder, Validators  } from '@angular/forms';
import {NgForm} from '@angular/forms';
import {Observable} from "rxjs";
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';

// import { Observable } from 'rxjs/Rx';
import {Subscription} from "rxjs";
import {Location} from '@angular/common';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import * as Communication from '../communication/index';

import {Config } from '../../environments/environment';
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {ToolbarEventPageEnum} from "../shared/common/ToolbarEvent";
import {NavigationService} from "../shared/common/NavigationEventService";
import {NotificationService} from "../shared/common/NotificationService";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import {ToolbarEvent} from "../shared/common/ToolbarEvent";
import {TranslateService} from '@ngx-translate/core';
import {Authorization} from "../shared/authorization/authorization.component";
import { SegmentedOption } from '../shared/components/segmented-control/segmented-control.component';
import { SIGN_METHOD_ORDER, SIGN_METHODS, VIEWER_STUB, getSignMethodMeta, isSignMethodCode, SignMethodMeta } from '../shared/common/signing-method';
// import countries from "../../assets/countries.json";

declare var $:any;
declare var swal: any;

/**
 * This class represents the lazy loaded RequestComponent.
 */
@Component({
    selector: 'sd-request',
    templateUrl: 'request.component.html',
    styleUrls: ['request.component.css'],
    providers: [Communication.JobsService, Communication.RecipientsService, Communication.RecipientRequestService],
    standalone: false
})
export class RequestComponent implements OnInit, OnDestroy, OnChanges {

  @Input() job: Communication.Job;
  @Output() modalClosed = new EventEmitter();
  @Output() recipientAdded = new EventEmitter<Communication.Recipient>();
  @Output() recipientRemoved = new EventEmitter<Communication.Recipient>();
  @Output() recipientUpdated = new EventEmitter<Communication.Recipient>();
  @Output() jobUpdated = new EventEmitter<Communication.Job>();

  jobIDParameter:number;

  subject:string="";
  message:string="";

  //Add or Edit Recipient
  modalTitle:string="Add Recipient";
  //Add, Save Changes
  modalAction:string="Add";

  userPlan:Communication.Plan = null;

  returnUrl:string;
  theRecipient:Communication.Recipient;
  recipientState:string = "";

  timerSubscription:Subscription;
  subscriptions:Subscription[] = [];
  isDisabled:boolean=false;

  selectedContainer:number = 1;
  containers: Array<Container> = [];
  widgets: Array<Communication.Recipient> = [];
  maxOrderNo:number=1;
  nameSearchTerm: string = "";
  signTimeRangeFilter: string = '1year';
  signTimeFilterOptions: Array<{value: string, label: string}> = [
    { value: '3months', label: 'Last 3 months' },
    { value: '1year', label: 'Last 1 year' },
    { value: 'all', label: 'All' }
  ];
  addressBook: Array<{
    id:number,
    recipientName:string,
    recipientEmail:string,
    recipientIdentity:string,
    recipientWorkflowEffect:string,
    recipientRole:string,
    isActive:boolean,
    smsRequired:string,
    smsCountryCode: string,
    signTime?: number,
    signMethod?: string
  }> = [];

  checkedAddressBookItems: Array<{
    id:number,
    recipientName:string,
    recipientEmail:string,
    recipientIdentity:string,
    recipientWorkflowEffect:string,
    recipientRole:string,
    isActive:boolean,
    smsRequired:string,
    smsCountryCode: string,
    signTime?: number,
    signMethod?: string
  }> = [];

  orderNoForAddressBook:number;
  nameFilterMultiplier:number = 1;
  emailFilterMultipler:number = 1;

  verificationRadioButton:string = "none";

  // Explicit signing-method selection
  signMethodSegments: SegmentedOption[] = [];
  tckEnabled = false;
  smsEnabled = false;

  countryFlags:Array<{
    fileName:string,
    countryCode:string
    isoCode:string,
    phoneLength:number,
    countryName:string
  }> = require('../../assets/jsonFiles/countries/countries.json')

  currentCountryFlag:{
    fileName:string,
    countryCode:string
    isoCode:string,
    phoneLength:number,
    countryName:string
  };

  constructor(
    private jobsApi:Communication.JobsService,
    private recipientApi: Communication.RecipientsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toolbarService: ToolbarService,
    private authorization: Authorization,
    private notificationService: NotificationService,
    public translate: TranslateService
  ){



  }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['job'] && this.job) {
      // When job input changes, update related properties
      this.showRecipientOrderList();
      this.updateSubjectAndMessage();
    }
  }

  ngOnInit(){

    if (!this.authorization.authenticated()) {
      this.router.navigate(['/']);
    } else {

      this.InitializePopovers();

      this.subscriptions.push(this.activatedRoute.params.subscribe(
        (param) => {
          this.jobIDParameter = +param['id'];
          console.log("jobIDParameter:" + this.jobIDParameter);

          if (param['id'] == null) {
            //TODO:ERROR
            this.notificationService.showAccessDenied();
            return;
          }

          // Job is now passed as @Input, no need to fetch
          this.showRecipientOrderList();
          this.updateRecipientOrders();
          this.userPlan = this.authorization.userAccount.subscription.plan;
          console.log("user plan: ",this.userPlan);

        })
      );

      let self = this;
      this.countryFlags.sort(function(a:any,b:any){
        let countryOne = self.translate.instant(a.countryName);
        let countryTwo = self.translate.instant(b.countryName);
        return countryOne.localeCompare(countryTwo)
      });

      this.InitModel();
      this.checkVerificationRadioButton("none");
      this.buildSignMethodSegments();
    }
  }

  // Segmented control options (qes/bio/initials + Görüntüle stub)
  private buildSignMethodSegments() {
    this.signMethodSegments = SIGN_METHOD_ORDER.map(code => {
      const meta = SIGN_METHODS[code];
      return {
        value: meta.code,
        label: this.translate.instant(meta.labelKey),
        icon: meta.icon,
        accent: meta.accent
      } as SegmentedOption;
    });
    this.signMethodSegments.push({
      value: VIEWER_STUB.code,
      label: this.translate.instant(VIEWER_STUB.labelKey),
      icon: VIEWER_STUB.icon,
      accent: VIEWER_STUB.accent,
      stub: true
    });
  }

  get activeMethodMeta(): SignMethodMeta | null {
    return getSignMethodMeta(this.theRecipient?.signMethod);
  }

  // Committed method change from the segmented control: clear stale identity
  // values for the methods we're leaving and derive the identity toggle state.
  onSignMethodChange(method: string) {
    if (!isSignMethodCode(method)) {
      return;
    }
    if (method !== 'qes') {
      this.theRecipient.citizenId = '';
      this.tckEnabled = false;
    }
    if (method !== 'bio') {
      this.theRecipient.smsRequired = '';
      this.theRecipient.smsCountryCode = Config.PHONE_CODE_NUMBER.toString();
      this.smsEnabled = false;
    }
    if (method === 'qes') {
      this.tckEnabled = !!(this.theRecipient.citizenId && this.theRecipient.citizenId.length > 0);
    }
    if (method === 'bio') {
      this.smsEnabled = this.checkIfSmsIsActive();
    }
  }

  // Görüntüle / Parola / OTP are out-of-scope stubs: notify and revert (no commit).
  onSignMethodStub() {
    this.notificationService.featureNotPlanned();
  }

  onTckToggle(enabled: boolean) {
    this.tckEnabled = enabled;
    if (!enabled) {
      this.theRecipient.citizenId = '';
    }
  }

  onSmsToggle(enabled: boolean) {
    this.smsEnabled = enabled;
    if (!enabled) {
      this.theRecipient.smsRequired = '';
      this.theRecipient.smsCountryCode = Config.PHONE_CODE_NUMBER.toString();
    }
  }


  // Floating Labels
  getClasses(input:string):any{
    if(input && input.trim().length > 0) return "is-visible";
    else return "animate";
  }




 // initialize model here
  InitModel(){
    this.theRecipient = {
      id: 0,
      jobLocationForRecipient: "",
      jobNameForRecipient: "",
      orderno: "",
      share: 0,
      smsSent: "",
      status: "",
      sufficientshare: 0,
      updated: 0,
      name: '',
      email: '',
      citizenId: '',
      role:'SIGNER', //VIEWER, COPY
      workflowEffect:'OWNER', //OPTIONAL, REQUIRED
      smsRequired: '',
      smsCountryCode: Config.PHONE_CODE_NUMBER.toString(),
      signMethod: 'qes'
    }
    this.tckEnabled = false;
    this.smsEnabled = false;
    this.countryFlags.forEach(element => {
      if(element.countryCode == Config.PHONE_CODE_NUMBER.toString()){
        this.pickCountry(element);
      }
    });
  }


  public showAddModal() {
    this.modalTitle = "Add Recipient";
    this.modalAction = "Add";
    this.InitModel();
    this.isDisabled = false;
    this.checkVerificationRadioButton('none');
    $("#myModal").modal('show'); //open add modal
  }

  public showAddressBookModal(addressBookAction:string, index?:number) {
    if(index != undefined && index != null){
      this.orderNoForAddressBook = index;
    }

    this.subscriptions.push(
      this.recipientApi.recipientsAddressbookGet(
        this.authorization.getAccessToken()
      ).subscribe(
        (response:any) => {

          console.log(response);
          this.addressBook = [];

          response.forEach(
            (element:Recipient) => {
              this.addressBook.push({
                id: element.id,
                recipientName: element.name,
                recipientEmail: element.email,
                recipientIdentity: element.citizenId,
                recipientWorkflowEffect: '',
                recipientRole: element.role,
                isActive: false,
                smsRequired: element.smsRequired,
                smsCountryCode: element.smsCountryCode,
                signTime: element.signTime,
                signMethod: element.signMethod
              })
            }
          );

          this.containers.forEach(
            (containerElement:Container) => {
              containerElement.widgets.forEach(
                (widgetElements:Recipient) => {
                  this.addressBook.forEach(
                    (addressBookElement) => {
                      if(addressBookElement.recipientEmail?.toLowerCase() == widgetElements.email?.toLowerCase()){
                        addressBookElement.isActive = true;
                      }
                    }
                  )
                }
              )
            }
          )

          this.modalTitle = "Address Book";
          this.modalAction = addressBookAction;
          $("#addressBookModal").modal('show');
        },
        (error) => {
          let json = JSON.parse(error._body);
          if(json.code == 254){
            this.notificationService.addressBookIsEmpty();
            console.log("Address book is empty");
          }
        }
      )
    )

  }
  dropContainer(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.containers, event.previousIndex, event.currentIndex);
  }

  dropWidget(event: CdkDragDrop<any[]>, containerIndex: number) {
    if (event.previousContainer === event.container) {
      moveItemInArray(this.containers[containerIndex].widgets, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
    this.updateRecipientOrders();
  }

  /**
   * Get IDs of all recipient drop lists for connecting them together
   * Allows recipients to be dragged between containers
   */
  getRecipientListIds(): string[] {
    return this.containers.map((_, index) => `recipient-list-${index}`);
  }

  get filteredAddressBook() {
    let filtered = this.addressBook;

    // Apply name filter
    if (this.nameSearchTerm) {
      filtered = filtered.filter(item =>
        item.recipientName.toLowerCase().includes(this.nameSearchTerm.toLowerCase())
      );
    }

    // Apply date range filter (excludes recipients without signTime unless 'all')
    const now = Date.now();
    const msPerMonth = 30 * 24 * 60 * 60 * 1000;

    if (this.signTimeRangeFilter === '3months') {
      const cutoffTime = now - (3 * msPerMonth);
      filtered = filtered.filter(item => item.signTime && item.signTime >= cutoffTime);
    } else if (this.signTimeRangeFilter === '1year') {
      const cutoffTime = now - (12 * msPerMonth);
      filtered = filtered.filter(item => item.signTime && item.signTime >= cutoffTime);
    }
    // 'all' - no filtering, show all including those without signTime

    return filtered;
  }

  public addRecipient(formData: any) {
    $("#myModal").modal('hide'); //hide add modal
    console.log(formData);
    console.log("selected-max OrderNo: " + this.selectedContainer + " - "+ this.maxOrderNo);

    // Identity is derived from the explicit method + its toggle state
    const signMethod = this.theRecipient.signMethod;
    formData.citizenId = (signMethod === 'qes' && this.tckEnabled) ? this.theRecipient.citizenId : "";
    formData.smsRequired = (signMethod === 'bio' && this.smsEnabled) ? this.theRecipient.smsRequired : "";
    formData.smsCountryCode = (signMethod === 'bio' && this.smsEnabled)
      ? this.currentCountryFlag.countryCode
      : Config.PHONE_CODE_NUMBER.toString();

    formData.email = formData.email?.toLowerCase();

    this.subscriptions.push(this.recipientApi.jobsIdRecipientsPost(
      this.authorization.getAccessToken(),
      this.jobIDParameter,
      formData.name,
      formData.email,
      formData.citizenId,
      formData.role,
      formData.workflowEffect,
      String(this.selectedContainer),
      formData.smsRequired,
      formData.smsCountryCode,
      signMethod
    ).subscribe(
      (response: Communication.Job) => {
        console.log(response);
        this.notificationService.recipientAdded(formData.name);

        this.job = response;
        this.jobUpdated.emit(response);

        // Find the newly added recipient and emit
        const newRecipient = response.recipients.find(r =>
          r.email?.toLowerCase() === formData.email?.toLowerCase() && r.name === formData.name
        );
        if (newRecipient) {
          this.recipientAdded.emit(newRecipient);
        }

        if(response.recipients.length == 1){
          this.showRecipientOrderList();
        }

        setTimeout(() => { this.updateRecipientOrders(); }, 0);

      }, //Bind to view
      (err:any) => {
        console.log(err);
        let errorObject = JSON.parse(err._body)
        if(errorObject.code == 265){
          this.notificationService.smsQuotaIsFull();
        } else {
          this.notificationService.displayError(err);
        }

        if(this.selectedContainer > this.maxOrderNo )
          this.selectedContainer--;
      }
    ));
  }

    sortByProperty(property:any, type:string){
      let filterMultiplier:number;

      if(type === "EMAIL"){
        this.emailFilterMultipler = this.emailFilterMultipler*-1;
        filterMultiplier = this.emailFilterMultipler;
      } else if(type === "NAME"){
        this.nameFilterMultiplier = this.nameFilterMultiplier*-1;
        filterMultiplier = this.nameFilterMultiplier;
      }

      return function(a:any,b:any){
        if(a[property] > b[property])
          return filterMultiplier;
        else if(a[property] < b[property])
          return filterMultiplier*-1;
        return 0;
      }

    }

    nameFilterClicked(){
      console.log(
        this.addressBook.sort(this.sortByProperty("recipientName","NAME"))
      );
    }

    emailFilterClicked(){
      console.log(
        this.addressBook.sort(this.sortByProperty("recipientEmail","EMAIL"))
      );
    }

    onAddressBookCheckboxChange(
      formData:{
        id:number,
        recipientName:string,
        recipientEmail:string,
        recipientIdentity:string,
        recipientWorkflowEffect:string,
        recipientRole:string,
        isActive:boolean,
        smsRequired:string,
        smsCountryCode: string,
        signMethod?: string
      }
    ) {
      let isChecked = $("#"+formData.id).prop("checked");
      if(isChecked){
        this.checkedAddressBookItems.push(formData);
      } else {
        let index = this.checkedAddressBookItems.indexOf(formData);
        if(index !== -1){
          this.checkedAddressBookItems.splice(index,1);
        }
      }
      console.log(this.checkedAddressBookItems);
    }

    public addRecipientFromAddressBook() {

      if(this.modalAction == "PARALLEL") {
        this.selectedContainer = this.orderNoForAddressBook;
      }

      console.log("selected-max OrderNo: " + this.selectedContainer + " - "+ this.maxOrderNo);

      // Creates new group and add all the selected recipient to that single group
      if(this.modalAction == "SERIAL"){
        this.selectedContainer = this.maxOrderNo + 1;
      }

      for(let i=0;i<this.checkedAddressBookItems.length;i++){
        let formData = this.checkedAddressBookItems[i];
        formData.recipientEmail = formData.recipientEmail?.toLowerCase();
        const prefilledSignMethod = isSignMethodCode(formData.signMethod) ? formData.signMethod : 'qes';
        this.subscriptions.push(
          this.recipientApi.jobsIdRecipientsPost(
            this.authorization.getAccessToken(),
            this.jobIDParameter,
            formData.recipientName,
            formData.recipientEmail,
            formData.recipientIdentity,
            formData.recipientRole,
            formData.recipientWorkflowEffect,
            String(this.selectedContainer),
            formData.smsRequired,
            formData.smsCountryCode,
            prefilledSignMethod
          ).subscribe(
            (response:Communication.Job) => {
              console.log(response);
              this.notificationService.recipientAdded(formData.recipientName);

              this.job = response;
              this.jobUpdated.emit(response);

              // Find the newly added recipient and emit
              const newRecipient = response.recipients.find(r =>
                r.email?.toLowerCase() === formData.recipientEmail?.toLowerCase() && r.name === formData.recipientName
              );
              if (newRecipient) {
                this.recipientAdded.emit(newRecipient);
              }

              if(response.recipients.length == 1){
                this.showRecipientOrderList();
              }

              this.checkedAddressBookItems = [];
              setTimeout(() => { this.updateRecipientOrders(); }, 0);
              $("#addressBookModal").modal('hide');

            }, //Bind to view
            (err:any) => {
              // Log errors if any
              console.log(err);
              this.notificationService.displayError(err);

              this.checkedAddressBookItems = [];

              if(this.selectedContainer > this.maxOrderNo )
                this.selectedContainer--;
            }
          )
        );
      }
    }

    checkIfSmsIsActive(){
      if(this.theRecipient.smsRequired != null && this.theRecipient.smsRequired != ""){ // içerisi değişecek
        return true;
      }
      return false;
    }

    public showUpdateModal(formData: Communication.Recipient) {
      this.modalTitle = "Update Recipient";
      this.modalAction = "Update";
      this.theRecipient.id = formData.id;
      this.theRecipient.name = formData.name;
      this.theRecipient.email = formData.email;
      this.theRecipient.citizenId = formData.citizenId;
      this.theRecipient.role = formData.role;
      this.theRecipient.workflowEffect = formData.workflowEffect;
      this.theRecipient.smsRequired = formData.smsRequired;
      this.theRecipient.smsCountryCode = formData.smsCountryCode;
      // Restore explicit method; legacy-null falls back to qes for editing
      this.theRecipient.signMethod = isSignMethodCode(formData.signMethod) ? formData.signMethod : 'qes';
      this.tckEnabled = !!(this.theRecipient.citizenId && this.theRecipient.citizenId.length == 11);
      this.smsEnabled = this.checkIfSmsIsActive();

      this.countryFlags.forEach(element => {
        if(this.theRecipient.smsCountryCode == element.countryCode){
          this.pickCountry(element);
        }
      });

      //if user is recipient, cant change his own email
      if(formData.email?.toLowerCase() == this.job.user.email?.toLowerCase())
        this.isDisabled = true;
      else this.isDisabled = false;

      $("#myModal").modal('show'); //open edit modal
    }

    public updateRecipient(formData: Communication.Recipient) {
      $("#myModal").modal('hide'); //hide edit modal
      console.log("theRecipient " + formData.email,formData);

      // Identity is derived from the explicit method + its toggle state
      const signMethod = formData.signMethod;
      formData.citizenId = (signMethod === 'qes' && this.tckEnabled) ? formData.citizenId : "";
      formData.smsRequired = (signMethod === 'bio' && this.smsEnabled) ? formData.smsRequired : "";
      formData.smsCountryCode = (signMethod === 'bio' && this.smsEnabled)
        ? this.currentCountryFlag.countryCode
        : Config.PHONE_CODE_NUMBER.toString();

      formData.email = formData.email?.toLowerCase();
      let updatedRecipient = { id:formData.id, name: formData.name, email: formData.email, citizenId:formData.citizenId , smsRequired: formData.smsRequired, smsCountryCode: formData.smsCountryCode, signMethod: signMethod };

      this.subscriptions.push(this.recipientApi.recipientsIdPut(
        this.authorization.getAccessToken(),
        formData.id,
        formData.name,
        formData.email,
        formData.citizenId,
        formData.role,
        formData.workflowEffect,
        formData.smsRequired,
        formData.smsCountryCode,
        signMethod,
      ).subscribe(
        (response:Communication.ResponseMessage) => {
          console.log("recipient updated...");
          let dumpJob = this.job;

            for (let i=0; i<dumpJob.recipients.length; i++) {
              if(dumpJob.recipients[i].id == updatedRecipient.id){
                dumpJob.recipients[i].email = updatedRecipient.email;
                dumpJob.recipients[i].name = updatedRecipient.name;
                dumpJob.recipients[i].citizenId = updatedRecipient.citizenId;
                dumpJob.recipients[i].smsRequired = updatedRecipient.smsRequired;
                dumpJob.recipients[i].smsCountryCode = updatedRecipient.smsCountryCode;
                dumpJob.recipients[i].signMethod = updatedRecipient.signMethod;

                this.job = dumpJob;
                this.jobUpdated.emit(this.job);
                this.recipientUpdated.emit(dumpJob.recipients[i]);
                this.showRecipientOrderList();
              }
            }
          this.notificationService.recipientUpdated();
        }, //Bind to view
        err => {
          console.log(err);
          let errorObject = JSON.parse(err._body)
          if(errorObject.code == 265){
            this.notificationService.smsQuotaIsFull();
          } else {
            this.notificationService.displayError(err);
          }
        }
      ));

    }



  public showRemoveAlert(formData: Communication.Recipient) {
    let _thisRecipient = this;
    this.notificationService.showRecipientDeleteAlert(function (isConfirmed: boolean) {
      if (isConfirmed)
        _thisRecipient.DeleteRecipient(formData);
    });
  }

  public DeleteRecipient(formData: Communication.Recipient){
   let recipientName = formData.name;
   this.subscriptions.push(this.recipientApi.recipientsIdDelete(
    this.authorization.getAccessToken(),
    formData.id
   ).subscribe(
        (response) => {
           if (response.code == 200) {
              this.notificationService.recipientDeleted(recipientName);

              // Emit before removing from array
              this.recipientRemoved.emit(formData);

              console.log("recipient count: " + this.job.recipients.length);
              let index = this.job.recipients.indexOf(formData);
              this.job.recipients.splice(index,1);

             console.log("recipient count: " + this.job.recipients.length);



              setTimeout(() => {
                this.showRecipientOrderList();
                this.updateRecipientOrders();
                }, 0);
            }
        },
        (err) => {
          // Log errors if any
          console.log(err);
          this.notificationService.displayError(err);
        }
   ));
  }



   public GetTheJob()
   {
      this.subscriptions.push(this.jobsApi.jobsIdGet(
        this.authorization.getAccessToken(),
        this.jobIDParameter
      ).subscribe(
      (response:Communication.Job) => {

      this.job = response;
      this.jobUpdated.emit(response);

      for (let recipient of this.job.recipients) {
        if(response.user.email?.toLowerCase() == recipient.email?.toLowerCase())
          this.recipientState = recipient.status;
      }

      this.showRecipientOrderList();
      this.updateSubjectAndMessage();


      this.toolbarService.action(new ToolbarEvent(ToolbarEventPageEnum.JOB_SIGN_REQUEST, response.type, response.user.id, this.recipientState, response.name, response.status, response.location, "", ""));

      //console.log("GetTheJob - status "+ this.theJob.status);

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
   }


   updateSubjectAndMessage() {
     if (!this.job) return;

     if(!this.job.subject){
       if(this.translate.currentLang == "tr"){
         this.subject = "'"+this.job.name +"' "+ this.translate.instant("Approval required for") ;
       }
       else{
         this.subject = this.translate.instant("Approval required for")+ " '"+this.job.name +"'";
       }
     }
     else
       this.subject = this.job.subject;

     if(!this.job.message)
       this.message = this.translate.instant("Hello") + ",\n\n" + this.translate.instant("The related document has been sent for signature.") + "\n\n" + this.authorization.userProfile.user_metadata.name + "\n\n";
     else
       this.message = this.job.message;
   }

   showRecipientOrderList()
   {
     if (!this.job) return;

     this.containers = [];
     this.maxOrderNo = 1;

     for (let recipient of this.job.recipients) {
       //console.log(recipient.email +"-"+recipient.orderno);
       if(Number(recipient.orderno) > this.maxOrderNo) {
         this.maxOrderNo = Number(recipient.orderno);
         //console.log("maxOrderNo: " + this.maxOrderNo)
       }
     }

     for (let i=1; i<=this.maxOrderNo; i++) {
       let orderGroup:Array<Communication.Recipient> = [];

       for (let recipient of this.job.recipients) {
         if(Number(recipient.orderno) == i)
           orderGroup.push(recipient);
       }

       //if(orderGroup.length > 0) {
         //console.log("orderGroup: "+ i +". - lenght: "+ orderGroup.length)
         this.containers.push(new Container(orderGroup));
       //}
     }
   }


  updateRecipientOrders()
  {
    let recipientOrders:string = "";
    for(let container of this.containers)
    {
      for (let recipient of container.widgets)
      {
        recipientOrders += recipient.id + ","; // add , between parallel recipients
      }

      if(recipientOrders.endsWith(','))
        recipientOrders = recipientOrders.substring(0, recipientOrders.length - 1); // remove last comma
      if(recipientOrders.endsWith('|') && container.widgets.length == 0)
        recipientOrders += " ";

      recipientOrders += "|"; // add | between serial recipients
    }

    recipientOrders = recipientOrders.substring(0, recipientOrders.length - 1); // remove last |
    //console.log("recipientOrders " + recipientOrders)

    // if exist any recipient number
    let match = (/\.*[0-9].*$/i).test(recipientOrders);

    if (match) {
      this.subscriptions.push(this.jobsApi.jobsIdRecipientsPut(
        this.authorization.getAccessToken(),
        this.jobIDParameter,
        recipientOrders
      ).subscribe(
        (response:Communication.Job) => {
          console.log("recipient order saved...");

          response.subject = this.subject;
          response.message = this.message;
          this.job = response;
          this.jobUpdated.emit(response);
          this.showRecipientOrderList();

        }, //Bind to view
        err => {
          // Log errors if any
          console.log(err);
        }
      ));
    }
  }



   public saveJob(){
     this.subscriptions.push(this.jobsApi.jobsIdActionsSavePut(
       this.authorization.getAccessToken(),
       this.jobIDParameter,
       this.subject,
       this.message
     ).subscribe(
       response => {
         //this.notificationService.jobSaved(this.job.name);
         console.log("job saved...");
         this.job.subject = this.subject;
         this.job.message = this.message;
         this.jobUpdated.emit(this.job);
       }, //Bind to view
       err => {
         // Log errors if any
         console.log(err);
         this.notificationService.displayError(err);
       }
     ));
   }



   public FinishRecipientSettings(){
     //save recipient order
     this.updateRecipientOrders();
     this.saveJob();

     let containerOK:boolean=true;
     let isSuitToContinue:boolean=true;
     for(let i=0; i<this.containers.length; i++)
     {
       if (this.containers[i].widgets.length == 0) {
         isSuitToContinue = false;
         containerOK = false;
         let self = this;
         this.notificationService.showRecipientOrderContainerDeleteAlert(i + 1, function (isConfirmed: boolean) {
           if (isConfirmed) {
             self.containers.splice(i, 1);
             self.maxOrderNo--;
             console.log("self.maxOrderNo: " + self.maxOrderNo)
             // save new recipient order
             self.updateRecipientOrders();
           }
         });
       }
     }


     let self = this;
     setTimeout(function(){
       if(isSuitToContinue)
       {
         if(self.job?.recipients?.length === 0) //imza için recipient olmalı
           self.notificationService.noRecipientExist();
         else{
           $("#requestModal").modal("hide");
           self.modalClosed.emit({
             value: false
           })
         }
       }

     }, 500);

  }

  hideModal(){
    let self = this;
    $("#requestModal").modal("hide");
    self.modalClosed.emit({
      value: false
    })
  }


  InitializePopovers(){
    $('#name').popover({
      title: this.translate.instant('Name'),
      content: this.translate.instant('Name as exactly on Citizen Card.'),
      placement: 'right',
      trigger: 'focus',
      template: '<div class="popover bg-default" style="min-width:200px; max-height:200px;"><div class="arrow"></div><div class="popover-content"></div></div>'
    });

      $('#email').popover({
      title: this.translate.instant('Email'),
      content: this.translate.instant('Email address that you want to send the request.'),
      placement: 'right',
      trigger: 'focus',
      template: '<div class="popover bg-default" style="min-width:200px; max-height:200px;"><div class="arrow"></div><div class="popover-content"></div></div>'
    });

    $('#citizenId').popover({
      title: this.translate.instant('citizenId'),
      content: this.translate.instant('Citizen ID will be checked on the signature if you fill the information.'),
      placement: 'right',
      trigger: 'focus',
      template: '<div class="popover bg-default" style="min-width:200px; max-height:200px;"><div class="arrow"></div><div class="popover-content"></div></div>'
    });

    $('#smsRequired').popover({
      title: this.translate.instant('smsRequired'),
      content: this.translate.instant('Phone number will be used for SMS Verification.'),
      placement: 'right',
      trigger: 'focus',
      template: '<div class="popover bg-default" style="min-width:200px; max-height:200px;"><div class="arrow"></div><div class="popover-content"></div></div>'
    });
  }

  calculateUnaminity(){
    let i;
    let hideLabel = true;
    for(i=0;i<this.containers.length;i++){
      for(let j=0;j<this.containers[i].widgets.length;j++){
        if(this.containers[i].widgets[j].sufficientshare != null){
          hideLabel = false;
          break;
        }
      }
    }
    return hideLabel;
  }

  checkVerificationRadioButton(type:string){
    this.verificationRadioButton = type;
    $('#'+type+'RadioButton').prop("checked", true);

    if(this.verificationRadioButton == "none" || this.modalAction == "Add"){
      this.theRecipient.citizenId = "";
      this.theRecipient.smsRequired = "";
      this.theRecipient.smsCountryCode = Config.PHONE_CODE_NUMBER.toString();
    } else if (this.verificationRadioButton == "mobile") {
      this.theRecipient.citizenId = "";
    } else if (this.verificationRadioButton == "identity"){
      this.theRecipient.smsRequired = "";
      this.theRecipient.smsCountryCode = Config.PHONE_CODE_NUMBER.toString();
    }

  }

  calculatePhoneNumberLength(data:{fileName:string,countryCode:string,isoCode:string,phoneLength:number,countryName:string}){
    let phoneLength;
    this.countryFlags.forEach(element => {
      if(element.countryCode == data.countryCode){
        phoneLength = element.phoneLength;
      }
    });
    return phoneLength;
  }

  pickCountry(data:{fileName:string,countryCode:string,isoCode:string,phoneLength:number,countryName:string}){
    this.currentCountryFlag = data;
    this.theRecipient.smsCountryCode = data.countryCode;
  }

  ngOnDestroy() {

     $('.modal-backdrop').remove(); //browser ileri-geri tuşuna basıncaki kırıklığı önlemek

      this.subscriptions.forEach(
        (s:Subscription) => s.unsubscribe()
      );
      if (this.timerSubscription != null) {
        this.timerSubscription.unsubscribe();
      }
  }

}

class Container {
  constructor(public widgets: Array<Communication.Recipient>) {}
}
